module.exports = __webpack_public_path__ + "img/MvEvents.66dc267a.svg";